import { Component, OnInit } from '@angular/core';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { MultiOpreationModel } from 'src/app/interface/dto';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-auto-mark-saq',
  templateUrl: './auto-mark-saq.component.html',
  styleUrls: ['./auto-mark-saq.component.scss']
})

export class AutoMarkSAQComponent implements OnInit {
  requireCaseMatching: boolean = false;
  requireStrictSpelling: boolean = false;
  reassessAllScripts: boolean = false;
  allowSynonyms: boolean = false;

  constructor(
    private popoverRef: PopoverRef<AutoMarkSAQComponent>,
    private examService: ExamService,
    private examSchService: ExamScheduleService,
    private snackBar: SnackbarService,
  ) {}

  ngOnInit() {}

  async autoMark() {
    try {
      let selectedExamID = this.examService.selectedExamIds[0];
      let selectedCandidate = Array.isArray(this.examSchService.selectedIds) && this.examSchService.selectedIds.length > 0
        ? this.examSchService.selectedIds.map(x => parseInt(x))[0]
        : 0;

      let data: MultiOpreationModel = {
        examinationID: this.examService.selectedExamIds.length > 1 ? 0 : selectedExamID,
        examinationScheduleID: this.examSchService.selectedIds.length > 1 ? 0 : selectedCandidate,
        selectAllSch: this.examSchService.selectAll,
        selectAllExam: this.examService.selectAll,
        examIds: this.examService.selectedExamIds,
        scheduleIds: this.examSchService.selectedIds.map(x => parseInt(x)),
        requireCaseMatching: this.requireCaseMatching,
        requireStrictSpelling: this.requireStrictSpelling,
        reassessAllScripts: this.reassessAllScripts,
        allowSynonyms: this.allowSynonyms,

      };

      await this.examService.autoMarkSAQ(data).then((res: any) => {
        this.snackBar.success('SAQ Auto-Marking started successfully');
        this.examService.reloadGrid.next(true);
        this.examSchService.reloadGrid.next(true);
        this.close();
      });
    } catch (error) {
      this.snackBar.error('Failed to start SAQ auto-marking. Please try again later.');
      console.error(error);
    }
  }

  close() {
    this.popoverRef.close();
  }
}
